import React, { ReactNode } from 'react';
import { Menu } from '../../block/Menu.client';
import { getSidebarMenu } from '@/lib/drupal/get-menus.server';
import { DrupalTaxonomyTermProduct } from '@/types';
import { getActiveTrail } from '@/lib/drupal/util';
import { DrupalMenuLinkContent } from 'next-drupal';

export const SidebarVersionedMenu = async ({product, version, children, path}: {
  product: DrupalTaxonomyTermProduct
  children?: ReactNode
  version?: string
  path: string
}) => {

  let menu = await getSidebarMenu(product.field_menu.resourceIdObjMeta.drupal_internal__target_id, version)

  if (product.field_flag_product_navigation) {
    const trail = getActiveTrail(menu, path)
    if (!trail || !trail[0].items) {
      return <></>
    }
    menu = trail[0].items as DrupalMenuLinkContent[]
  }

  return (
    <nav className="pr-10" aria-label="Section" id="sectionNavigation">
      {children}
      <Menu 
        menu={menu}
        className="flex flex-col text-navy-600" 
        id="sidebar-menu" 
        query={ version ? `v=${version}` : undefined } 
        queryMatchBasePath={product.path.alias} />
    </nav>
  )
}

export const SidebarVersionedMenuLoading = (props: {
  children?: ReactNode
}) => {
  return (
    <div className="pr-10">
      {props.children}
      <nav className="flex flex-col text-navy-600 animate-pulse" id="sidebar-menu">
          <p className="bg-gray-500 py-1">&nbsp;</p>
          <p className="bg-gray-500 my-4 py-8">&nbsp;</p>
          <p className="bg-gray-500 my-4 py-5">&nbsp;</p>
          <p className="bg-gray-500 my-4 py-10">&nbsp;</p>
          <p className="bg-gray-500 my-4 py-24">&nbsp;</p>
      </nav>
    </div>
  )
}